import { render, staticRenderFns } from "./SrModalPageFormFooter.vue?vue&type=template&id=4ade4e5a"
import script from "./SrModalPageFormFooter.vue?vue&type=script&lang=js"
export * from "./SrModalPageFormFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports